import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/all-customers/$customerId')({
  beforeLoad: ({ params }) => getTitleContextSlice(`Edit Customer: ${params.customerId}`),
  staticData: {
    owner: CodeOwner.Frontend,
  },
});
